module.exports = __webpack_public_path__ + "static/media/arrow.8bb72250.svg";